import {CSSProperties, ReactNode, useState} from "react";
import classes from "./QRCodeViewSorting.module.css";
import {Popover, PopoverProps, PopoverStylesNames} from "@mantine/core";
import {IconCaretDownFilled} from "@tabler/icons-react";
import SortButton from "./button/SortButton";
import QRCodeViewSortingContext from "./QRCodeViewSortingContext";

/**
 * Popover styles
 * @since 0.1.9
 * @author Kacper Faber
 */
const popoverStyles:  Partial<Record<PopoverStylesNames, CSSProperties>> = {
    dropdown: {
        padding: '0.4rem'
    }
};

/**
 * Some basic popover props.
 * Still we have onChange etc. attributes written in invocation
 * @since 0.1.9
 * @author Kacper Faber
 */
const popoverProps: PopoverProps = {
    width: 200,
    position: 'bottom',
    withArrow: true,
    shadow: 'md',
    styles: popoverStyles
}

/**
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function QRCodeViewSorting() {
    /**
     * Is popover opened.
     * setOpened() does not open popover really.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const [opened, setOpened] = useState(false);

    /**
     * To be called when popover changed open state.
     * @author Kacper Faber
     * @since 0.1.8
     * @param e
     */
    const onPopoverChanged = (e: boolean) => {
        setOpened(e);
    }

    const wrapContext = (children: ReactNode) => {
        return (
            <QRCodeViewSortingContext.Provider
                value={{setOpened, opened}}
                children={children}
            />
        );
    };


    /**
     * Toggle the opened state
     * @since 0.1.9
     * @author Kacper Faber
     */
    const toggle = () => {
        setOpened(!opened);
    }

    return wrapContext(
        <Popover {...popoverProps} opened={opened} onChange={onPopoverChanged}>
            <Popover.Target>
                <div className={classes.root} onClick={toggle}>
                    Sortowanie

                    <IconCaretDownFilled
                        className={classes.icon}
                        style={{transform: opened ? "rotate(-180deg)" : ''}}
                    />
                </div>
            </Popover.Target>

            <Popover.Dropdown>
                <SortButton
                    sortBy="id"
                    label="ID"
                />

                <SortButton
                    sortBy="created_at"
                    label="Data utworzenia"
                />

                <SortButton
                    sortBy="name"
                    label="Nazwa"
                />
            </Popover.Dropdown>
        </Popover>
    );
}

export default QRCodeViewSorting;

// TODO: QRCodeViewSorting.tsx
//  Introduce used colours in theme